import { Zap, Award, CheckCircle2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export default function CourseDetails({ course }) {
  return (
    <div className="space-y-10">
      {/* Title & Description */}
      <div>
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight mb-4 text-foreground">
          {course.title}
        </h1>
        <p className="text-lg text-muted-foreground leading-relaxed">
          {course.description}
        </p>
      </div>

      <hr className="border-border" />

      {/* Modules Section */}
      <div>
        <h2 className="text-2xl font-bold mb-6 flex items-center gap-2">
          <Zap className="w-6 h-6 text-primary" /> {course.modulesTitle || "Technologies Covered"}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {course.modules.map((module, idx) => (
            <Card key={idx} className="flex items-start gap-3 bg-card p-4 rounded-xl border-border shadow-sm">
              <div className="mt-0.5 w-5 h-5 rounded-full bg-primary/10 text-primary flex items-center justify-center shrink-0 font-bold text-xs">
                {idx + 1}
              </div>
              <span className="text-foreground font-medium text-sm leading-snug">{module}</span>
            </Card>
          ))}
        </div>
      </div>

      <hr className="border-border" />

      {/* Benefits Section */}
      <div>
        <h2 className="text-2xl font-bold mb-6 flex items-center gap-2">
          <Award className="w-6 h-6 text-primary" /> Program Benefits
        </h2>
        <div className="space-y-4">
          {course.benefits.map((benefit, idx) => (
            <div key={idx} className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-success shrink-0 mt-0.5" />
              <span className="text-foreground text-base">{benefit}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
